var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#AC39AC",
    d: "M19.385 4.328c-.666-.558-1.596-.387-2.08.38l-6.92 10.964-3.81-4.47c-.562-.691-1.505-.725-2.105-.075-.6.646-.63 1.733-.065 2.42 0 0 4.63 5.566 5.296 6.125.665.558 1.596.387 2.08-.38l7.934-12.568c.485-.77.335-1.841-.33-2.396"
  })));
};
export default SvgCheck;